<template>
  <div
    class="raffle__numbers"
    :class="{'': static}"
  >
    <div
      v-if="!static"
      v-for="(number, index) in numbersToUse"
      :key="index"
      class="raffle__number"
    >
      {{ number }}
    </div>

    <div v-else class="raffle__number">
      {{ static.substring(0,1) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'

const props = defineProps({
  static: {type: String, required: false, default: undefined},
})

function useRaffleNumbers(digits: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], repetitions: number = 3) {
  return computed((): number[] => {
    return Array.from({ length: digits.length * repetitions }, (_, i) =>
      digits[i % digits.length]
    )
  })
}
const customNumbers = useRaffleNumbers([0, 1, 2, 3, 4, 5, 6, 7, 8, 9], 3)

const numbersToUse = customNumbers
</script>

<style scoped>
</style>